import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { useMediaQuery } from '@mantine/hooks';

import { useGetMenuThirdParty } from 'api/integrations/useGetMenuThirdParty';
import { HeadquarterContext } from 'context/HeadquarterContext';
import { getAppOrderDirectDomain } from 'helpers/url';
import { breakpoints } from 'styles/theme.variables';

import { ThirdPartyMenusView } from './ThirdPartyMenusView';

type ThirdPartyMenusProps = {
  source: string;
};

/**
 * Container that fetches third-party synced menus for the current location
 * and renders them via `ThirdPartyMenusView`. The `source` prop is forwarded
 * to the API hook (which lowercases it before sending).
 */
export const ThirdPartyMenus: FunctionComponent<ThirdPartyMenusProps> = ({ source }) => {
  const { location } = useContext(HeadquarterContext);
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.maxMobile})`);

  const {
    hasGetMenuThirdPartyRequestError,
    isGetMenuThirdPartyRequestLoading,
    getMenuThirdPartyRequestResponse,
  } = useGetMenuThirdParty(location?.id, source);

  const menus = getMenuThirdPartyRequestResponse?.menus ?? [];
  const { company_id: companyId, id: locationId } = location ?? {};
  const activeMenuHref = `${getAppOrderDirectDomain()}/${companyId}/locations/${locationId}?menu_status=preview`;

  return (
    <ThirdPartyMenusView
      isLoading={isGetMenuThirdPartyRequestLoading}
      hasError={hasGetMenuThirdPartyRequestError}
      menus={menus}
      activeMenuHref={activeMenuHref}
      isMobile={isMobile}
    />
  );
};
